import { render, staticRenderFns } from "./Wzsm.vue?vue&type=template&id=4d000c4c&"
import script from "./Wzsm.vue?vue&type=script&lang=js&"
export * from "./Wzsm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports